import { Dispatch } from 'redux'

import {
  actionTypes,
  fetchUsersListError,
  toggleUserRoleError,
  fetchUsersListSuccess,
  toggleUserRoleSuccess,
  fetchAllRolesListError,
  toggleUserLocationError,
  fetchAllRolesListSuccess,
  AdminFetchUsersListAction,
  AdminToggleUserRoleAction,
  toggleUserLocationSuccess,
  fetchAllLocationsListError,
  fetchAllLocationsListSuccess,
  AdminFetchAllRolesListAction,
  AdminToggleUserLocationAction,
  AdminFetchAllLocationsListAction
} from './actions'

import { RootState } from '../rootReducer'

import { User } from 'src/lib/interfaces/User.interface'
import { Location } from 'src/lib/interfaces/Location.interface'
import { UserAuthority } from 'src/lib/interfaces/UserAuthority.interface'

import * as adminApi from 'src/lib/api/admin'

const { createLogic } = require('redux-logic')

type OnDoneType = () => void

const onFetchUsersListLogic = createLogic({
  type: actionTypes.ADMIN_FETCH_USERS_LIST,
  process({ action }: { action: AdminFetchUsersListAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    adminApi.getUsers()
      .then((users: User[]) => {
        dispatch(fetchUsersListSuccess(users))
        if (next) { next(null, users) }
      })
      .catch(err => {
        dispatch(fetchUsersListError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

const onFetchAllLocationsListLogic = createLogic({
  type: actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST,
  process({ action }: { action: AdminFetchAllLocationsListAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    adminApi.getAllLocations()
      .then((locations: Location[]) => {
        dispatch(fetchAllLocationsListSuccess(locations))
        if (next) { next(null, locations) }
      })
      .catch(err => {
        dispatch(fetchAllLocationsListError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

const onFetchAllRolesListLogic = createLogic({
  type: actionTypes.ADMIN_FETCH_ALL_ROLES_LIST,
  process({ action }: { action: AdminFetchAllRolesListAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    adminApi.getAllRoles()
      .then((roles: UserAuthority[]) => {
        dispatch(fetchAllRolesListSuccess(roles))
        if (next) { next(null, roles) }
      })
      .catch(err => {
        dispatch(fetchAllRolesListError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

const onToggleUserRoleLogic = createLogic({
  type: actionTypes.ADMIN_TOGGLE_USER_ROLE,
  process({ action }: { action: AdminToggleUserRoleAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, role, toggle, userId } = action.payload

    let promise
    if (toggle) { promise = adminApi.addUserRole(userId, role) }
    else { promise = adminApi.deleteUserRole(userId, role) }

    promise
      .then((user: User) => {
        dispatch(toggleUserRoleSuccess(user))
        if (next) { next(null, user) }
      })
      .catch(err => {
        dispatch(toggleUserRoleError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

const onToggleUserLocationLogic = createLogic({
  type: actionTypes.ADMIN_TOGGLE_USER_LOCATION,
  process({ action }: { action: AdminToggleUserLocationAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, toggle, userId, locationId } = action.payload

    let promise
    if (toggle) { promise = adminApi.addUserLocation(userId, locationId) }
    else { promise = adminApi.deleteUserLocation(userId, locationId) }

    promise
      .then((user: User) => {
        dispatch(toggleUserLocationSuccess(user))
        if (next) { next(null, user) }
      })
      .catch(err => {
        dispatch(toggleUserLocationError(err))
        if (next) { next(err) }
      })
      .then(done)
  }
})

export const adminLogicList = [
  onFetchUsersListLogic,
  onFetchAllLocationsListLogic,
  onFetchAllRolesListLogic,
  onToggleUserRoleLogic,
  onToggleUserLocationLogic
]



// WEBPACK FOOTER //
// ./src/store/admin/logic.ts